import React from 'react';
import PropTypes from 'prop-types';
import { NumberField } from 'react-admin';
import { connect } from 'react-redux';

const formatLocale = locale => locale.replace('_', '-');

const CurrencyField = ({ locale = 'en-US', record, ...props }) => {
  const currency = record.currency || 'USD';
  const formattedLocale = formatLocale(locale);

  return (
    <NumberField
      locales={formattedLocale}
      record={record}
      options={{
        style: 'currency',
        currency,
      }}
      {...props}
    />
  );
};

CurrencyField.propTypes = {
  locale: PropTypes.string,
  record: PropTypes.shape({
    currency: PropTypes.string,
  }),
};

const mapStateToProps = state => ({
  locale: state.i18n.locale,
});

export default connect(mapStateToProps)(CurrencyField);
